export default __webpack_public_path__ + "static/bubble-with-categories-745296d60719cc368fd6d314e50329fb.png";